import '../common/theme.mjs';
import '../common/direction.mjs';
import { ControlType, Priority } from '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import '../common/propsValues/size.mjs';
import '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import '@transferwise/icons';
import 'clsx';
import 'react';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import 'react/jsx-runtime';

const typeClassMap = {
  [ControlType.ACCENT]: 'btn-accent',
  [ControlType.POSITIVE]: 'btn-positive',
  [ControlType.NEGATIVE]: 'btn-negative'
};
const priorityClassMap = {
  [Priority.PRIMARY]: 'btn-priority-1',
  [Priority.SECONDARY]: 'btn-priority-2',
  [Priority.TERTIARY]: 'btn-priority-3'
};

export { priorityClassMap, typeClassMap };
//# sourceMappingURL=classMap.mjs.map
